/* import __COLOCATED_TEMPLATE__ from './active-incentive-program-progress.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { ActiveIncentiveProgramProgressRequest } from '@square/dashboard-protos/models/squareup/bbfrontend/v1/client_service';
let ActiveIncentiveProgramProgress = (_class = class ActiveIncentiveProgramProgress extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "bbFrontendClientApi", _descriptor, this);
    _initializerDefineProperty(this, "sentry", _descriptor2, this);
    _initializerDefineProperty(this, "showProgress", _descriptor3, this);
    _initializerDefineProperty(this, "completed", _descriptor4, this);
    _initializerDefineProperty(this, "title", _descriptor5, this);
    _initializerDefineProperty(this, "description", _descriptor6, this);
    _initializerDefineProperty(this, "daysLeftText", _descriptor7, this);
    _initializerDefineProperty(this, "percentage", _descriptor8, this);
    this.initialize();
  }
  get progressBarStyles() {
    return `width: ${100 * this.percentage}%`;
  }
  async initialize() {
    try {
      const response = await this.bbFrontendClientApi.client.getActiveIncentiveProgramProgress(ActiveIncentiveProgramProgressRequest.create({
        unitToken: this.args.unitToken
      }));

      /**
       * this means that there is no active incentive program for unit and component
       * should stay hidden
       */
      if (!response.incentiveProgram) {
        return;
      }
      const {
        title,
        inProgress,
        completed,
        percentage
      } = response.incentiveProgram;
      this.title = title || '';
      this.percentage = percentage;
      if (completed) {
        this.completed = true;
        this.description = completed.completedText?.html || '';
      } else {
        this.description = inProgress?.progressText || '';
        this.daysLeftText = inProgress?.daysLeftText || '';
      }
      this.showProgress = true;
    } catch (error) {
      this.sentry.captureException(error);
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "bbFrontendClientApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "sentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "showProgress", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "completed", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "title", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "description", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "daysLeftText", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "percentage", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _applyDecoratedDescriptor(_class.prototype, "initialize", [action], Object.getOwnPropertyDescriptor(_class.prototype, "initialize"), _class.prototype), _class);
export { ActiveIncentiveProgramProgress as default };